export default __webpack_public_path__ + "static/media/Danske_Bank_Logo_CMYK.574ad66e.png";